import React, { useEffect, useState } from "react";
import { DeviceMobile, X } from "@phosphor-icons/react";

const STORAGE_KEY = "factlify_install_dismissed";

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    if (!localStorage.getItem("factlify_cookies_v1")) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setVisible(false);
    }
    setDeferredPrompt(null);
  };

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-30 bg-ink text-white border-2 border-ink shadow-brutal-lg p-4 flex items-center gap-3 animate-fade-in">
      <DeviceMobile size={28} weight="bold" className="shrink-0 text-safety" />
      <div className="flex-1 min-w-0">
        <div className="font-bold text-sm leading-tight">Instalar Factlify</div>
        <div className="text-xs text-slate-300 mt-0.5 leading-snug">
          Accede más rápido desde tu móvil sin abrir el navegador.
        </div>
      </div>
      <div className="flex flex-col gap-1 shrink-0">
        <button onClick={install}
          className="px-3 py-1.5 bg-safety text-white font-bold uppercase tracking-wider text-[10px] hover:bg-safety/90 transition-colors">
          Instalar
        </button>
        <button onClick={dismiss}
          className="px-3 py-1.5 border border-slate-500 text-slate-300 font-bold uppercase tracking-wider text-[10px] hover:text-white hover:border-white transition-colors flex items-center justify-center gap-1">
          <X size={10} weight="bold" /> No, gracias
        </button>
      </div>
    </div>
  );
}
